import {
  AspectRatio,
  Badge,
  Body,
  Box,
  Heading,
  Icon,
  Image,
  Link,
  SimpleGrid,
  SimpleGridProps,
} from '@hover/blueprint';
import { iArrowRight } from '@hover/icons';
import { Link as GatsbyLink } from 'gatsby';
import React, { FC } from 'react';
import BLOG_CATEGORIES from '../../../constants/blog-categories';
import { IBlogPost } from '../../../interfaces/IBlogPost';
import ArrowLink from '../../ui/ArrowLink';

interface Props extends SimpleGridProps {
  post: IBlogPost;
}

const BlogHeroPost: FC<Props> = ({ post, ...rest }) => {
  const postCategoryData = BLOG_CATEGORIES.find(
    item => item.value === post.categories[0],
  );
  return (
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      spacing={{ base: 0, desktop: 100 }}
      alignItems="center"
      {...rest}
    >
      <Box flexDir="column" maxW="lg" mb={{ base: 700, desktop: 0 }}>
        {postCategoryData ? (
          <Box pb={{ base: 500, tablet: 800 }}>
            <Badge
              colorScheme={postCategoryData.color}
              variant="brand"
              textTransform="uppercase"
            >
              {postCategoryData.value}
            </Badge>
          </Box>
        ) : null}
        {post?.author ? (
          <Box pb={200}>
            <Body color="neutral.700" size={300} fontStyle="italic">
              {post.author}
            </Body>
          </Box>
        ) : null}
        <Heading
          color="neutral.700"
          size={{ base: 500, tablet: 700 }}
          marginBottom={{ base: 400, tablet: 500 }}
          isLight
        >
          {post.title}
        </Heading>
        <Body
          color="neutral.700"
          size={500}
          pb={500}
          display={{ base: 'none', tablet: 'flex' }}
        >
          {post.description.description.replace('\\[…\\]', '')}
        </Body>
        <ArrowLink
          as={GatsbyLink}
          display={{ base: 'none', tablet: 'flex' }}
          to={`${process.env.GATSBY_V2_PREFIX}/blog/${post.slug}`}
        >
          Read more
        </ArrowLink>
      </Box>
      <AspectRatio ratio={3 / 2}>
        <Image
          pb={{ base: 500, tablet: 0 }}
          src={post.heroImage.fluid.src}
          alt={post.description.description}
          objectFit="cover"
        />
      </AspectRatio>
      <Body
        color="neutral.700"
        size={500}
        pb={500}
        fontWeight={{ base: 400, tablet: 400 }}
        display={{ base: 'flex', tablet: 'none' }}
      >
        {post.description.description.replace('\\[…\\]', '')}
      </Body>
      <Link
        as={GatsbyLink}
        to={`${process.env.GATSBY_V2_PREFIX}/blog/${post.slug}`}
        display={{ base: 'block', tablet: 'none' }}
      >
        <Box flexDirection="row" alignItems="center" justifyContent="start">
          <Body color="primary.600" size={500} isSemiBold>
            Read more
          </Body>
          <Icon icon={iArrowRight} color="primary.600" />
        </Box>
      </Link>
    </SimpleGrid>
  );
};

export default BlogHeroPost;
